import { ArdoqId } from '@ardoq/api-types';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { loadedCurrentUser$ } from 'streams/currentUser/currentUser$';

export const currentOrganizationId$: Observable<ArdoqId> =
  loadedCurrentUser$.pipe(
    map(currentUser => currentUser.organization._id),
    distinctUntilChanged()
  );
